
import React, { useCallback } from 'react'
import { SetSaveEvent, SetDeleteEvent } from '../../../commonApis/formEvents'
import { useCurrentShipmentType } from '../../hooks/useCurrentShipmentType';
import { useHttp } from '../../hooks/useHttp';

export const useEvent=(containerKey,isOverrideParam=false)=>{
 const {isLoading,post,error}=useHttp()
 const {isImportShipment,saveEvent,deleteEvent, shipmentId}=useCurrentShipmentType()
  const saveForm = useCallback((params,isLoading=true,event='') => {// adding extra param event because it is diferent in item tab
     try{
      let dataSent = SetSaveEvent(event || saveEvent,{
          [`${containerKey}`]: isOverrideParam ? params : {
             ...params
          },

          shipmentId: shipmentId
    });   
      
    return post(dataSent,isLoading, shipmentId);
     }
     catch{

     }
  }, [post,isImportShipment,shipmentId]);

  const deleteForm = useCallback((params) => {
   try{
    let dataSent = SetDeleteEvent(deleteEvent,{
        [`${containerKey}`]:params,
        shipmentId: shipmentId

  });
 
  return post(dataSent);
   }
   catch{

   }
}, [post,isImportShipment,shipmentId]);

  return React.useMemo(()=>({isLoading,deleteForm,saveForm,error}),[isLoading,deleteForm,saveForm,error])
}